import { Pipe, PipeTransform } from '@angular/core';

import { ToPlainText } from '../utils/to-plain-text';

@Pipe({
  name: 'toPlainText',
  standalone: true,
  pure: true
})
export class ToPlainTextPipe implements PipeTransform {
  transform(htmlText: string): string {
    return ToPlainText(htmlText);
  }
}
